<template>
  <v-autocomplete
    v-bind:value="value"
    v-on:change="handleChange"
    :loading="loading"
    :items="membersAndTeams"
    chips
    hide-no-data
    item-text="fullName"
    item-value="id"
    hide-details
    multiple
    single-line
    label="Search by name"
    outlined
    :disabled="disabled"
    :search-input.sync="search"
  >
    <template v-slot:label> <slot name="label"></slot> </template>
    <template v-slot:selection="data">
      <user-chip
        v-if="isUser(data.item)"
        :user="data.item"
        close
        v-on:close="remove(data.item)"
        v-on:click="remove(data.item)"
      ></user-chip>
      <team-chip
        v-else
        :team="data.item"
        close
        v-on:close="remove(data.item)"
        v-on:click="remove(data.item)"
      ></team-chip>
    </template>
    <template v-slot:item="data">
      <user-chip v-if="isUser(data.item)" :user="data.item"></user-chip>
      <team-chip v-else :team="data.item"></team-chip>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MemberTeamAutocomplete",
  components: {},
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    search: null
  }),
  computed: {
    isUser() {
      return item => {
        return item.id.indexOf("user|") >= 0;
      };
    },
    membersAndTeams() {
      let members = this.members.map(member => ({
        id: "user|" + member.id,
        fullName: member.fullName,
        avatarUrl: member.avatarUrl
      }));
      let selectedUsers = this.value.filter(x => {
        if (x.id) {
          return x.id.indexOf("user|") == 0;
        }
        return false;
      });
      let list = this.teams
        .map(team => ({
          id: "team|" + team.id,
          fullName: team.fullName
        }))
        .concat(members)
        .concat(selectedUsers);
      return list;
    },
    ...mapGetters({
      members: "user/search_users",
      teams: "team/teams"
    })
  },
  created() {
    this.$store.dispatch("team/getTeams");
    this.getUsers();
  },
  methods: {
    handleChange(e) {
      this.$emit("change", e);
      this.search = "";
    },
    remove(item) {
      let index = this.value.findIndex(cv => cv.id == item.id);
      if (index == -1) {
        index = this.value.findIndex(cv => cv == item.id);
      }
      if (index >= 0) this.value.splice(index, 1);
      this.handleChange(this.value);
    },
    getUsers() {
      this.loading = true;
      this.$store.dispatch("user/searchUsers", {}).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
